<div class="modal-header">
    <h2 class="modal-title">{{'headerMenu.settingsActions.cssFileTitle' | translate}}</h2>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeHandler()">
    </button>
</div>
<div class="modal-body">
    <div class="section-box mb-5">
        <div class="description-txt mb-3">{{'headerMenu.settingsActions.downloadCssFileLabel' | translate}}</div>
        <button class="btn action-btn bg-black text-white" (click)="downloadHandler()" download="cssFile.css">{{'common.download' | translate}}</button>
    </div>

    <div class="section-box">
        <div class="description-txt mb-3">{{'headerMenu.settingsActions.uploadCssFileLabel' | translate}}</div>
        <label for="upload" class="btn primary-btn action-btn">{{'common.upload' | translate}}</label>
        <input id="upload" class="invisible" type="file" (change)="uploadHandler($event)"/>
    </div>
</div>
